import {assert} from 'assert-ts';
import type { ConcreteEntityType} from 'types';
import {Concept} from 'types';
import {isAgentValue} from './isAgentValue';
import {isCollectionValue} from './isCollectionValue';
import {isPrizeValue} from './isPrizeValue';
import {isWorkMetadataValue} from './isWorkMetadataValue';

export const getConcreteEntityType = (
  value: unknown,
): ConcreteEntityType | undefined => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }

  if (isAgentValue(value)) {
    return value.agentType;
  }

  if (isCollectionValue(value)) {
    return value.collectionType;
  }

  if (isWorkMetadataValue(value)) {
    return Concept.work;
  }

  if (isPrizeValue(value)) {
    return Concept.prize;
  }

  // TODO: Links, add manifestation and expression
  assert(false, 'getConcreteEntityType: unknown value', {value});
};
